import React from 'react';
import PromptToReload from './PromptToReload';
import PromptToStart from './PromptToStart';
import PromptToViewResults from './PromptToViewResults';
import WaitForLoading from './WaitForLoading';

const ContentLoader = ({
  isAlreadySubmitted,
  isLoading,
  isLoadingFailure,
  isStarted,
  children,
}) => {
  if (isLoading) {
    return <WaitForLoading />;
  } else if (isLoadingFailure) {
    return <PromptToReload />;
  } else if (isAlreadySubmitted) {
    return <PromptToViewResults />;
  } else if (!isStarted) {
    return <PromptToStart />;
  } else {
    return children;
  }
};
export default ContentLoader;
